import { themeAtom } from "../../shared/atoms";
import { useAtomValue } from "jotai";
import { twMerge } from "tailwind-merge";

export function BoolBadge({ v }: { v: string | null | undefined }) {
  const theme = useAtomValue(themeAtom);

  const norm = String(v).trim().toLowerCase();

  return (
    <span
      className={twMerge(
        "text eme inline-flex items-center justify-center rounded-full px-2 py-0.5 text-xs capitalize",
        norm === "yes"
          ? twMerge(theme.uwhcAssistant.boolBadge.yesBg, theme.uwhcAssistant.boolBadge.yesText)
          : norm === "no"
            ? twMerge(theme.uwhcAssistant.boolBadge.noBg, theme.uwhcAssistant.boolBadge.noText)
            : twMerge(theme.uwhcAssistant.boolBadge.unknownBg, theme.uwhcAssistant.boolBadge.unknownText),
      )}
      title={v === null ? "Unknown" : String(v)}
    >
      {v ?? "—"}
    </span>
  );
}
